import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import { Button, Card, CardBody, Col, Input, Modal, Row, Table } from "reactstrap";
// import {
//     GET_DT_CAPACITY,
//     GET_DT_CAPACITY_COLUMN,
//     SAVE_DT_CAPACITY,
//     SAVE_DT_CAPACITY_COLUMN,
// } from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import BootstrapTable from "react-bootstrap-table-next";
import DemandComparison from "./DemandComparison/DemandComparison";
import PropTypes from "prop-types";
import SupplyDemand from "./SupplyDemand/SupplyDemand";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SectionSystemEntry(props) {
    // console.log(props);
    const dispatch = useDispatch();
    // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
    //     "YYYY-MM-DD"));



    return (
        <Row>
            <Col sm="12">
                <Card style={{ backgroundColor: "#0087ff1a" }}  className="mb-1">
                    <CardBody>

                        <SupplyDemand date={props.date} summaryReportPid={props.summaryReportPid}/>

                        <DemandComparison date={props.date } summaryReportPid={props.summaryReportPid}/>

                    </CardBody>
                </Card>
            </Col>
        </Row>

    )
}

SectionSystemEntry.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid:PropTypes.any
}

export default SectionSystemEntry